import compose from 'react-hooks-compose'

import { useMainPageLogic } from './useLogic'
import { MainPagePresenter } from './presenter'

export const MainPage = compose(props => ({
	useLogic: () => useMainPageLogic(props),
}))(MainPagePresenter)
